import * as Yup from 'yup';

export class OrganisationValidations {
  public static upsertOrganisationValidation() {
    return Yup.object().shape({
      name: Yup.string().required(),
      websiteUrl: Yup.string().url(),
      roles: Yup.array(),
      accreditedBy: Yup.number().nullable(),
      accreditationDate: Yup.date().nullable(),
      addressLine1: Yup.string().nullable(),
      addressLine2: Yup.string().nullable(),
      city: Yup.string().nullable(),
      state: Yup.string().nullable(),
      postalCode: Yup.string().nullable(),
      embeddedMap: Yup.string().nullable()
    });
  }
}
